import { render, staticRenderFns } from "./TributacionPage.vue?vue&type=template&id=2304af3c"
import script from "./TributacionPage.js?vue&type=script&lang=js&external"
export * from "./TributacionPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports